import React,{useState} from 'react'
import styled from 'styled-components'
import { DataGrid } from '@mui/x-data-grid';
import { colors } from '../../../Shared/colors';
import { useGetAllProjectsQuery } from '../../../features/projectSlice';

export const ProjectsDataTable = () => {
  const [pageSize, setPageSize] = useState(50);

let {data:Projects} = useGetAllProjectsQuery()

let isLoading= false
  const columns = [
    {
      field:'name',
      headerName:'Name',
      width:200,
    },
    {
      field:'type',
      headerName:'Type',
      width:200
    },
    {
      field: 'region',
      headerName: 'Region',
      width: 200,
    },
  ];
  let rows = [];
  Projects?.forEach(project => {
    rows.push({
      id:project._id,
      name:project.projectName,
      type:project.projectType,
      region:project.region.regionName
    })
  });
  return (
    <Main>
      <LeadsSection>
      Projects:<span> {Projects?.length}</span> 
      </LeadsSection>
      <Table>
      <DataGrid
        rows={rows}
        columns={columns}
        pageSize={pageSize}
        onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
        rowsPerPageOptions={[20,50,100]}
        checkboxSelection
        disableSelectionOnClick
        experimentalFeatures={{ newEditingApi: true }}
        loading={isLoading}
        sx={{
          border:'none'
        }}
      />
      </Table>
    </Main>
  )
}

const Main = styled.div`
width: 90%;
background-color: ${colors.white};
margin: 3em 0em;
height: 80vh;
padding: 0em 1em;
border-radius: 5px;
`

const LeadsSection = styled.p`
font-size: clamp(1.5em,1.5vh,2em);
padding: 0.5em 0em;
height: 10%;
span{
  font-weight: bold;
}
`

const Table = styled.div`
height: 90%;
`